import { Flex, Button, Row, Col, Card, Space, Dropdown, Typography, List, Empty } from "antd";
import React, { useEffect } from "react";
import HeadingSubHeading from "../../../components/ViewHeading/HeadingSubHeading";
import InfiniteScrollList from "../../../components/Forms/ListView/InfiniteScrollList";
import { MoreOutlined } from '@ant-design/icons';
import TeamsList from "./TeamsList";
import { MasterConfigs } from "../../../interfaces/entity";
import projectConfigs from "../../../entity/projects/projectConfig";
import FormSetup from "../../../components/Forms/FormSetup";

const { Text, Title } = Typography;

const ProjectTeams = () => {
    const [selectedProject, setSelectedProject] = React.useState(null);
    const [projectId, setProjectId] = React.useState(null);
    const [visible, setVisible] = React.useState(false);
    const [load, setLoad] = React.useState(false);


    const getFormColumns = (formItems) => {
        return projectConfigs.getFormColumns()
            .filter(e => formItems.includes(e.name))
    }

    const config: MasterConfigs = {
        ...projectConfigs,
        getFormColumns: () => [
            ...getFormColumns(['clientName', 'name',]),
            { span: 8 },
            ...getFormColumns(['startDate', 'endDate']),
            { span: 8 },
            {
                ...getFormColumns(['description'])[0],
                span: 16
            }
        ],
        onRefresh: () => onRefresh()
    };

    const onRefresh = () => {
        setSelectedProject(null)
        setProjectId(null)
        setLoad(true)
        setProjectId(null)
    }

    const onCancel = () => {
        setVisible(false)
        setVisible(false)
        setProjectId(null)
    }

    useEffect(() => {
        if (projectId) {
            setVisible(true)
        }
    }, [projectId])

    return <>
        <FormSetup config={config} id={projectId} onClose={onCancel} isModal={true} open={visible} />
        <Flex justify="space-between">
            <HeadingSubHeading
                title="Teams"
                subTitle="Manage your project teams"
            />
            <Button type="primary" onClick={() => setVisible(true)}>Add Project</Button>
        </Flex>
        <Row gutter={[16, 16]}>
            <Col span={4}>
                <Card
                    title="Projects"
                    className="custom-card"
                >
                    <InfiniteScrollList
                        apiUrl="/projects"
                        height={618}
                        itemsPerPage={20}
                        reload={load}
                        onLoaded={() => setLoad(false)}
                        renderItem={(item) => {
                            return <List.Item key={item.name}
                                className={(selectedProject?._id == item?._id ? 'active_list' : '') + " plan-item"}
                                style={{ paddingLeft: 20 }}
                                onClick={() => setSelectedProject(item)}>
                                <Space direction="vertical" style={{ width: '100%' }}>
                                    <Title style={{ marginBottom: 0, lineHeight: 1.2 }} level={5}>{item?.name}</Title>
                                    <Text>{item?.clientName}</Text>
                                </Space>
                            </List.Item >
                        }}
                    />
                </Card>
            </Col>
            <Col span={20}>
                <Card>
                    <Space direction="vertical" style={{ width: '100%' }} size={[10, 10]}>
                        {selectedProject?._id && <Flex justify="space-between">
                            <Space direction="vertical">
                                <Title level={5} style={{ marginBottom: 0, lineHeight: 1.2 }}>{selectedProject?.name}</Title>
                                <Text type="secondary">{selectedProject?.clientName}</Text>
                            </Space>
                            {selectedProject?._id && <Dropdown menu={{
                                items: [{
                                    key: '1',
                                    label: 'Edit',
                                }],
                                onClick: (e) => {
                                    setProjectId(selectedProject?._id)
                                }
                            }}>
                                <Button icon={<MoreOutlined />} type="text" />
                            </Dropdown>}
                        </Flex>}
                        {selectedProject && <TeamsList key={selectedProject._id} projectId={selectedProject?._id} />}
                    </Space>
                    {!selectedProject?._id && <Flex style={{ height: '100%' }} justify="space-evenly" align="center">
                        <Empty description="Please select a project" />
                    </Flex>}
                </Card>
            </Col>
        </Row>
    </>
}

export default ProjectTeams;